import getAppRoot from '../../utils/getAppRoot';

export default ({ store }: { store: any }) => () => {
  const rootStore = getAppRoot(store);
  rootStore.model.refreshCalendarRoutes();
};
